import {css} from '@emotion/css';
import { Link } from '@solidjs/meta';
import Cropper from 'cropperjs';
import { sharedTheme, sharedTheme as theme } from 'Shared/ThemeProvider';
import { useUrls } from 'Shared/SiteProvider';
import { createSignal, onCleanup, Show } from 'solid-js';
import { onMount } from 'solid-js';
import { Portal } from 'solid-js/web';


export function ImageCropper(P)
{
	const cropperStyle = css({
		position: 'fixed',
		left: 0,
		right: 0,
		top: 50,
		bottom: 0,
		zIndex: 50,
		backgroundColor: '#000',
	});

	const barStyle = css({
		position: 'fixed',
		left: 0,
		right: 0,
		top: 0,
		height: 50,
		backgroundColor: 'white',
	});

	let editor!:HTMLElement;
	let image!:HTMLImageElement;

	/* Prevent underlay from scrolling */
	onMount(() => {
		document.body.style.overflowY = 'hidden';

		onCleanup(() => {
			document.body.style.overflowY = '';
		});
	});

	const [loaded,setLoaded] = createSignal(false);

	const urls = useUrls();

	return (<>
		<Link rel='stylesheet' href={urls.buildUrl('resources/cropper.min.css')} />

		<Portal>
			<div ref={editor} class={css(sharedTheme().root,cropperStyle)}>
				<img ref={image} src={P.url} onLoad={() => setLoaded(true)} />

				<div class={barStyle}>
					<Show when={loaded()}>
						<BarContents {...P} editor={editor} image={image} />
					</Show>
				</div>
			</div>
		</Portal>
	</>);
}


function BarContents(P)
{
	const messageStyle = css({
		lineHeight: '50px',
		marginLeft: 20
	});

	const buttonStyle = () => css(theme().button,{
		position: 'absolute',
		right: 10,
		top: 10
	});

	if (P.image.height < P.minHeight || P.image.width < P.minWidth) {
		alert('The image is too small');
		P.setShowCrop(false);
		return; 
	}

	const cropper = new Cropper(P.image, {
		viewMode: 1,
		autoCropArea: 1.0,
		guides: false,
		center: false,
		zoomable: false,
		imageSmoothingEnabled: true,
		imageSmoothingQuality: 'high',
//BUG the box moves when trying to shrink a minimally sized box
		crop: (event:any) => {
			const width = event.detail.width;
			const height = event.detail.height;

			if (width < P.minWidth || height < P.minHeight) {
				cropper.setData({
					width: Math.max(P.minWidth,width),
					height: Math.max(P.minHeight,height),
				});
			}
		}
	});
	if (P.ratio!=undefined)
		cropper.setAspectRatio(P.ratio);

	const performCrop = () => {
		const canvas = cropper.getCroppedCanvas();
		canvas.toBlob(blob => P.done(blob), P.mimeType, /*quality*/0.95);
	};

	return (<>
		<div class={messageStyle}>
			Click and drag to crop image
		</div>
		<button class={buttonStyle()} onClick={performCrop}>Confirm</button>
	</>);
}

